import { Pipe, PipeTransform } from '@angular/core';
import { AuthenticationService } from 'src/app/auth/services/authentication.service';

@Pipe({
    name: 'tableShowColumns',
    pure: true
})
export class TableShowColumnsPipe implements PipeTransform {
  
    constructor(    
    private authenticationService:AuthenticationService
    ){}
  
    transform(tableColumns: []): any {
        if (this.authenticationService.hasRole() === '1' ){
            return tableColumns;
        }else{
            let onlyShowColumns = tableColumns.filter(v => v != 'org_name')
            return onlyShowColumns;
        }
    }

  }
  
  
  
  
  